export { getMultiLang, getPlatformLang } from './getMultiLang';
export { getLangData } from './methods';
